import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

import { isAuthenticated } from 'modules/auth/selectors'
import { SIGN_IN_PATH } from 'config'


const PrivateRoute = ({ isAuthenticated, component, ...rest }) => {
  return (
    <Route
      { ...rest }
      render={ props => {
        return isAuthenticated ?
          React.createElement(component, props) :
          <Redirect to={ SIGN_IN_PATH } />
      } }
    />
  )
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
  isAuthenticated: PropTypes.bool.isRequired,
}

export default connect(state => ({ isAuthenticated: isAuthenticated(state) }))(PrivateRoute)



// WEBPACK FOOTER //
// ./src/components/app/private-route.js